import React from "react";

import { Icon as WarningIcon } from "../../../../../res/img/warning.svg";

interface Props {
    className?: string;
    children: React.ReactNode;
}

const MediaProcessingError: React.FC<Props> = ({ className, children }) => (
    <div className={className}>
        <div className="mx_MediaProcessingError_container">
            <WarningIcon className="mx_MediaProcessingError_Icon" width="16" height="16" />
            {children}
        </div>
    </div>
);

export default MediaProcessingError;
